import { IProperty } from '../../data/entities/property';
import { IPropertySummary } from '../../data/entities/property-summary';

/**
 * The purpose of this function is to determine which mode a property should enter TBP with.
 * @param onboardingIncomplete boolean determined by the result of `has_ever_published` of all customer's properties.
 * See `customerIsComplete`.
 * @param property IPropertySummary object
 * @returns {string}
 */
export const getTbpModeForCustomerAndProperty = (onboardingIncomplete: boolean, property: IPropertySummary): string => {
	if (property.has_ever_published) return 'edit';
	if (!property.has_ever_published) {
		if (onboardingIncomplete) return 'onboard';
		return 'add';
	}
	return 'onboard';
};

export const customerIsIncomplete = (propertySummaries: IPropertySummary[]): boolean => {
	// This can happen when navigating back into portal from direct or messaging
	if (propertySummaries.length === 0) return false;
	if (propertySummaries.every((p) => p.has_ever_published === false)) return true;
	if (propertySummaries.some((p) => p.has_ever_published === true)) return false;
	return false;
};

/*
 * Returns true if the property has only one unpublished property
 * This is commonly used to identify if the user has just come out of onboarding
 */
export const hasOnlyOneUnpublishedProperty = (properties: IProperty[] | IPropertySummary[]): boolean => {
	return properties.length === 1 && !properties[0].published_at;
};
